import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
    {
        title: "General",
        lanClass: "lan-1",
        items: [
            {
                title: "Dashboard",
                id: 1,
                icon: "Home-dashboard",
                type: "link",
                path: `${process.env.PUBLIC_URL}/dashboard`,
                active: false,
                permission: "dashboard.view"
            },
            {
                title: "Bystander Management",
                id: 11,
                icon: "Contacts",
                type: "link",
                path: `${process.env.PUBLIC_URL}/bystander`,
                active: false,
                permission: "bystander-management.view"
            },
            {
                title: "Patient Management",
                id: 12,
                icon: "Activity",
                type: "link",
                path: `${process.env.PUBLIC_URL}/patient`,
                active: false,
                permission: "patient-management.view"
            },
            {
                title: "Booking Management",
                id: 13,
                icon: "Calendar",
                type: "link",
                path: `${process.env.PUBLIC_URL}/booking`,
                active: false,
                permission: "booking-management.view"
            },
            {
                title: "Payout Management",
                id: 14,
                icon: "Wallet",
                type: "link",
                path: `${process.env.PUBLIC_URL}/payout_management`,
                active: false,
                permission: "payout-management.view"
            },
            {
                title: "Expense Management",
                id: 16,
                icon: "Paper",
                type: "link",
                path: `${process.env.PUBLIC_URL}/expense`,
                active: false,
                permission: "expense-management.view"
            },
            {
                title: "Location Disable Logs",
                id: 21,
                icon: "Discovery",
                type: "link",
                path: `${process.env.PUBLIC_URL}/bystander-location-disable-logs`,
                active: false,
                permission: "location-disable-logs.view",
            },
            {
                title: "Duty / Status Logs",
                id: 22,
                icon: "Tick-square",
                type: "link",
                path: `${process.env.PUBLIC_URL}/bystander-status-logs`,
                active: false,
                permission: "duty-status-logs.view",
            },
        ]
    },
    {
        title: "Reports",
        lanClass: "lan-3",
        items: [
            {
                title: "Service Report",
                id: 17,
                icon: "Chart",
                type: "link",
                path: `${process.env.PUBLIC_URL}/service_report`,
                active: false,
                permission: "service-report.view",
            },
            {
                title: "Profitability Report",
                id: 18,
                icon: "Activity",
                type: "link",
                path: `${process.env.PUBLIC_URL}/profitability_report`,
                active: false,
                permission: "profitability-report.view",
            },
            {
                title: "Bystander Performance",
                id: 19,
                icon: "Profile",
                type: "link",
                path: `${process.env.PUBLIC_URL}/bystander_performance_report`,
                active: false,
                permission: "bystander-performance.view",
            },
            {
                title: "Patient Insights",
                id: 20,
                icon: "Contacts",
                type: "link",
                path: `${process.env.PUBLIC_URL}/patient_insights_report`,
                active: false,
                permission: "patient-insights.view",
            },
        ]
    },
    {
        title: "Master Settings",
        lanClass: "lan-2",
        items: [
            {
                title: "General Settings",
                id: 2,
                icon: "Setting",
                type: "link",
                path: `${process.env.PUBLIC_URL}/general_settings`,
                active: false,
                permission: "general-settings.view"
            },
            {
                title: "Role Management",
                id: 3,
                icon: "Shield",
                type: "link",
                path: `${process.env.PUBLIC_URL}/role`,
                active: false,
                permission: "role-management.view"
            },
            {
                title: "Employee Management",
                id: 4,
                icon: "Profile",
                type: "link",
                path: `${process.env.PUBLIC_URL}/employee`,
                active: false,
                permission: "employee-management.view"
            },
            {
                title: "Audit Logs",
                id: 16,
                icon: "Activity",
                type: "link",
                path: `${process.env.PUBLIC_URL}/audit_logs`,
                active: false,
                permission: "audit-logs.view"
            },
            {
                title: "Timing Settings",
                id: 15,
                icon: "Calendar",
                type: "link",
                path: `${process.env.PUBLIC_URL}/timing_settings`,
                active: false,
                permission: "timing-settings.view"
            },
        ],
    },
];